import { CircularProgress, Stack, Typography } from "@mui/material";
import React from "react";

const AVCTableLoading = () => {
  return (
    <Stack justifyContent="center" alignItems="center" height="100%" width="100%" spacing={2}>
      <CircularProgress />
      <Typography variant="subtitle2" color="primary.main">
        لطفا منتظر بمانید...
      </Typography>
    </Stack>
  );
};

export default AVCTableLoading;
